import React from 'react';
import PropTypes from 'prop-types';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { Link, Route, withRouter } from 'react-router-dom';

import { Page } from '../../components/page';
import { PATH } from './index';
import store from '../../store';

@withRouter @observer
export default class LocalAgreements extends React.Component {

	@observable isLoading = true;
	@observable records = [];
	
	constructor(props) {
		super(props);
		this.init();
	}
	
	init = async () => {
		const res = await store.model.Page.find({ where: { route: 'executive-functions-local' }, fields: ['id'] });
		const parent = res.length > 0 ? res[0] : null;
		if (parent) {
			this.records = await store.model.Page.find({ where: { parentId: parent.id }, fields: ['id', 'route', 'title'] });
		}
		this.isLoading = false;
	};
	
	render() {
		if (this.isLoading) return null;
		
		const localAgreementsLinks = this.records.map(record => <div key={record.id}>
			<Link to={`${PATH}/local/${record.route}`}>{record.title}</Link>
		</div>);
		
		const localAgreementsRoutes = this.records.map(record => (
			<Route
				key={record.id}
				path={`${PATH}/local/${record.route}`}
				render={() => <Page code={record.route} contentOnly />}
			/>
		));
		
		return <>
			<Route path={`${PATH}/local`} exact render={() => <>
				<Page code="executive-functions-local" contentOnly afterContent={localAgreementsLinks} />
			</>}/>
			{localAgreementsRoutes}
		</>;
	}
	
}
